const IconService = {
    getPuzzleTypeIcon: (type) => {
        switch (type) {
            case 'WORD_SEARCH': return '🔍';
            case 'HIDDEN_MESSAGE': return '💬';
            case 'CROSSWORD': return '📝';
            default: return '🧩';
        }
    },

    getPuzzleTypeTooltip: (type) => {
        switch (type) {
            case 'WORD_SEARCH': return 'This is a Word Search puzzle';
            case 'HIDDEN_MESSAGE': return 'This is a Hidden Message puzzle';
            case 'CROSSWORD': return 'This is a Crossword puzzle';
            default: return 'This is a puzzle';
        }
    }
};

export default IconService;
